export const extractYoutubeId = (link: string): string | null => {
    const match = link.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w-]{11})/);
    return match ? match[1] : null;
};

export const extractVimeoId = (link: string): string | null => {
    const match = link.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return match ? match[1] : null;
};

export const extractLoomId = (link: string): string | null => {
    const match = link.match(/loom\.com\/(?:share|embed)\/([a-zA-Z0-9]+)/);
    return match ? match[1] : null;
};

export interface VideoOEmbedMeta {
    thumbnailUrl: string | null;
    durationSeconds: number | null;
}

// Vimeo's oEmbed endpoint is public/CORS-enabled and needs no API key.
export const fetchVimeoMeta = async (link: string): Promise<VideoOEmbedMeta | null> => {
    try {
        const res = await fetch(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(link)}`);
        if (!res.ok) return null;
        const data = await res.json();
        return {
            thumbnailUrl: data?.thumbnail_url ?? null,
            durationSeconds: typeof data?.duration === "number" ? data.duration : null,
        };
    } catch {
        return null;
    }
};

// Loom's oEmbed endpoint is public/CORS-enabled and needs no API key.
export const fetchLoomMeta = async (link: string): Promise<VideoOEmbedMeta | null> => {
    try {
        const res = await fetch(`https://www.loom.com/v1/oembed?url=${encodeURIComponent(link)}`);
        if (!res.ok) return null;
        const data = await res.json();
        return {
            thumbnailUrl: data?.thumbnail_url ?? null,
            durationSeconds: typeof data?.duration === "number" ? data.duration : null,
        };
    } catch {
        return null;
    }
};
